import * as actionTypes from '../actionType';
const defaultState = {
  hasMore: true,
  loading: false,
  hasAsyncData: false,
  fullScreenLoading: false,
}
export default {
  hasAsyncData(state = defaultState.hasAsyncData, action) {
    const { type, payload } = action;
    switch (type) {
      case actionTypes.HAS_ASYNC_DATA:
        return payload;
      default:
    }

    return state;
  },
  hasMore(state = defaultState.hasMore, action) {
    const { type, payload } = action;
    switch (type) {
      case actionTypes.HAS_MORE:
        return payload;
      default:
    }

    return state;
  },
  loading(state = defaultState.loading, action) {
    const { type, payload } = action;
    switch (type) {
      case actionTypes.LOADING:
        return payload;
      default:
    }

    return state;
  },
  fullScreenLoading(state = defaultState.fullScreenLoading, action) {
    const { type, payload } = action;
    switch (type) {
      case actionTypes.FULL_SCREEN_LOADING:
        return payload;
      default:
    }

    return state;
  }
}